import './horizontal-info.scss';

import { Collapse } from 'antd';
import classNames from 'classnames';

import Chevron from '@/media/icons/chevron.svg?react';
import EditIcon from '@/media/icons/edit.svg?react';
import QuestionIcon from '@/media/icons/question-circle-outlined.svg?react';
import { formatPhoneNumber } from '@/services/formatter';
import { getUserInitials } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

import { getAutoInfo } from '../../helpers';

interface IProps {
  openEditModal?: () => void;
  onHistoryModalOpenChange: (value: boolean) => void;
}

const HorizontalInfo: React.FC<IProps> = ({
  openEditModal,
  onHistoryModalOpenChange
}) => {
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const autoInfo = getAutoInfo(request);

  return (
    <div className="ie-horizontal-info">
      <div className="ie-horizontal-info__client">
        <div className="ie-horizontal-info__name">
          <p className="ie-horizontal-info__name-text">
            {getUserInitials(request?.client)}
          </p>

          {openEditModal && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                openEditModal();
              }}
              className="ie-horizontal-info__edit"
            >
              <EditIcon />
            </button>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onHistoryModalOpenChange(true);
            }}
            className="ie-horizontal-info__history"
          >
            <QuestionIcon />
          </button>
        </div>

        <p className="ie-horizontal-info__person-id">
          ИИН: {request?.client?.clientIin},{' '}
          <span className="ie-horizontal-info__phone-wrapper">
            <a
              className="ie-horizontal-info__phone"
              href={`tel:${(request?.client?.phoneNumber || '').replace(/\(|\)|-|\s/g, '')}`}
            >
              {formatPhoneNumber(request?.client?.phoneNumber)}
            </a>
          </span>
        </p>
      </div>

      {request?.status.code !== 'leasing_draft' &&
        autoInfo.subjects.length > 0 && (
          <Collapse
            expandIconPlacement="end"
            className="ie-horizontal-info__request"
            expandIcon={({ isActive }) => (
              <span
                className={classNames('ie-horizontal-info__arrow', {
                  'ie-horizontal-info__arrow--rotated': isActive
                })}
              >
                <Chevron />
              </span>
            )}
            items={[
              {
                key: 'subjects',
                label: (
                  <span className="ie-horizontal-info__collapse-label">
                    {autoInfo.label}
                  </span>
                ),
                children: (
                  <div className="ie-horizontal-info__subjects">
                    {autoInfo.subjects.map((subject) => (
                      <div
                        className="ie-horizontal-info__subject"
                        key={subject.id}
                      >
                        <div>
                          <p className="ie-horizontal-info__subject-title">
                            {subject.title}
                          </p>
                          <p className="ie-horizontal-info__subject-meta">
                            {subject.quantityLabel}
                          </p>
                        </div>
                        <p className="ie-horizontal-info__subject-total">
                          {subject.lineTotal}
                        </p>
                      </div>
                    ))}
                    <div className="ie-horizontal-info__total">
                      <span>Итого</span>
                      <span>{autoInfo.amount || '0'} ₸</span>
                    </div>
                  </div>
                )
              }
            ]}
          />
        )}
    </div>
  );
};

export default HorizontalInfo;
